import React, { useState } from "react";
import "../styles/Header.css";
import { useNavigate } from "react-router-dom";
import { IoIosNotifications, IoMdSettings } from "react-icons/io";
import { TbLayoutDashboard } from "react-icons/tb";
import { IoLogOut } from "react-icons/io5";
import { useAdmin } from "../contexts/AdminContext";
import { FaRegCircleUser } from "react-icons/fa6";

const Header = () => {
  const { admin } = useAdmin();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = (forceClose = false) => {
    setDropdownOpen(forceClose ? false : !dropdownOpen);
  };

  const handleNavigation = (path) => {
    navigate(path);
    toggleDropdown(true); // Close dropdown after navigation
  };

  return (
    <div className="header">
      <div className="header-logo">
        <TbLayoutDashboard
          color="#ff0000"
          size={35}
          style={{ marginRight: 10 }}
        />
        <p>Dashboard</p>
      </div>
      <div className="header-icons">
        {/* <IoIosNotifications
          className="icon"
          color="#ff0000"
          onClick={() => navigate("/admin/notificationmanagement")}
        />
        <IoMdSettings
          className="icon"
          color="#ff0000"
          onClick={() => navigate("/admin/settings")}
        /> */}
        <IoLogOut
          className="icon"
          color="#ff0000"
          onClick={() => navigate("/admin/logout")}
        />
        <div className="profile-container">
          <p className="userAcountProfile" onClick={() => toggleDropdown()}>
            {(admin?.username || admin?.name)?.charAt(0).toUpperCase() +
              (admin?.username || admin?.name)?.slice(1)}
            <FaRegCircleUser className="avatar" />
          </p>

          {dropdownOpen && (
            <div className="dropdown">
              <p
                onClick={() => handleNavigation("/admin/profile")}
                className="dropdown-item"
              >
                Profile
              </p>
              <p
                onClick={() => handleNavigation("/admin/logout")}
                className="dropdown-item logoutBtn"
              >
                Logout
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
